/**
 * create storage key-value pairs manager object
 */
export function createStoragePairsMgr(storage, { key }) {
  return {
    key,

    clear() {
      storage.removeItem(this.key);
    },

    getOnce() {
      this.clear();

      return this.value;
    },

    get() {
      const jsonStr = storage.getItem(this.key);
      if (!jsonStr) {
        return null;
      }

      return JSON.parse(jsonStr) || null;
    },

    set(obj) {
      storage.setItem(this.key, JSON.stringify(obj));
    },
  };
}

export function createSessionStoragePairsMgr({ key }) {
  return createStoragePairsMgr(window.sessionStorage, { key });
}

export function createLocalStoragePairsMgr({ key }) {
  return createStoragePairsMgr(window.localStorage, { key });
}

/**
 * createShareCouponMgr
 */
export function createShareCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'shareCoupon' });
}

/**
 * createReceivedCouponMgr
 */
export function createReceivedCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'receivedCoupon' });
}

export function createLastOrderedDishesMgr() {
  const mgr = createLocalStoragePairsMgr({ key: 'lastOrderedDishes' });

  return {
    get({ shopId, type }) {
      const value = mgr.get();
      if (!value) {
        return null;
      }

      const { dishes, shopId: storedShopId, type: storedType, expires } = value;
      if (
        shopId === storedShopId &&
        type === storedType &&
        expires >= Date.now() &&
        dishes &&
        dishes.length
      ) {
        return dishes;
      }

      mgr.clear();
      return null;
    },

    set(lastOrderedDishes, { type, shopId, shopName = '' }) {
      mgr.set({
        dishes: lastOrderedDishes,
        shopId,
        type,
        shopName,
        expires: Date.now() + (24 * 60 * 60 * 1000),
      });
    },

    clear() {
      mgr.clear();
    },
  };
}



// WEBPACK FOOTER //
// ./src/helper/storage-pair-helper.js